/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { MedicalServiceDto } from './medical-service-dto';

/**
 * 
 * @export
 * @interface DoctorPricelistItemDto
 */
export interface DoctorPricelistItemDto {
    /**
     * 
     * @type {number}
     * @memberof DoctorPricelistItemDto
     */
    'additionalTimeGrossPrice'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DoctorPricelistItemDto
     */
    'docplannerEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DoctorPricelistItemDto
     */
    'doctorPackageOnly'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DoctorPricelistItemDto
     */
    'durationFrom'?: number;
    /**
     * 
     * @type {number}
     * @memberof DoctorPricelistItemDto
     */
    'durationTo'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DoctorPricelistItemDto
     */
    'dutyEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DoctorPricelistItemDto
     */
    'grossPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof DoctorPricelistItemDto
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DoctorPricelistItemDto
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {MedicalServiceDto}
     * @memberof DoctorPricelistItemDto
     */
    'medicalService'?: MedicalServiceDto;
    /**
     * 
     * @type {string}
     * @memberof DoctorPricelistItemDto
     */
    'patientType'?: DoctorPricelistItemDtoPatientTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DoctorPricelistItemDto
     */
    'visitOrder'?: DoctorPricelistItemDtoVisitOrderEnum;
    /**
     * 
     * @type {string}
     * @memberof DoctorPricelistItemDto
     */
    'visitType'?: DoctorPricelistItemDtoVisitTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum DoctorPricelistItemDtoPatientTypeEnum {
    Infant = 'INFANT',
    Child = 'CHILD',
    Youth = 'YOUTH',
    Adult = 'ADULT',
    Senior = 'SENIOR'
}
/**
    * @export
    * @enum {string}
    */
export enum DoctorPricelistItemDtoVisitOrderEnum {
    Each = 'EACH',
    First = 'FIRST',
    Next = 'NEXT'
}
/**
    * @export
    * @enum {string}
    */
export enum DoctorPricelistItemDtoVisitTypeEnum {
    Remote = 'REMOTE',
    Stationary = 'STATIONARY',
    Absent = 'ABSENT'
}


